import { TranslatedText } from '../Translation';

export interface Category {
  id: number;
  slug: string;
  name: string;
  nameTranslation: TranslatedText;
  parentID?: number;
  logo: string;
  banner: string;
  isActive: boolean;
  isSearchable: boolean;
  isPopular: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyCategory = (): Category => ({
  id: 0,
  slug: '',
  name: '',
  nameTranslation: {},
  logo: '',
  banner: '',
  isActive: false,
  isSearchable: false,
  isPopular: false,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const categoryFromResponse = (responseData: any): Category => ({
  id: responseData.id,
  slug: responseData.slug,
  name: responseData.name,
  nameTranslation: responseData.name_translation ?? {},
  parentID: responseData.parent_id,
  logo: responseData.logo,
  banner: responseData.banner,
  isActive: responseData.is_active,
  isSearchable: responseData.is_searchable,
  isPopular: responseData.is_popular,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const categoryToUpsertRequest = (category: Category) => ({
  name: category.name,
  name_translation: category.nameTranslation,
  parent_id: category.parentID,
  is_active: category.isActive,
  is_searchable: category.isSearchable,
  is_popular: category.isPopular,
});
